import React from "react";
import MaterialTable from "material-table";
import { tableIcons } from "../../shared/TableIcons";
import CircularProgress from "@material-ui/core/CircularProgress";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";

const AverageTimes = (props) => {
  const { data } = props;
  return (
    <div>
      {data !== "" && data !== [] ? (
        <MaterialTable
          icons={tableIcons}
          title="Μέσος χρόνος απόκρισης συνολικά"
          columns={[
            {
              title: "Κατάσταση",
              field: "status",
            },
            {
              title: "Μέσος χρόνος ανάθεσης (Λεπτά)",
              field: "acknowlegedTime",
            },
            { title: "Μέσος χρόνος κλεισίματος (Λεπτά)", field: "closureTime" },
          ]}
          data= {[data]}
          actions={[]}
          localization={{
            body: {
              emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
            },
            toolbar: {
              addRemoveColumns: "Προσθέστε ή αφαιρέστε κολώνες",
              showColumnsTitle: "Δείξτε κολώνες",
              addTooltip: "Προσθήκη",
              searchTooltip: "Αναζήτηση",
              searchPlaceholder: "Αναζήτηση",
              exportTitle: "Εξαγωγή",
              exportCSVName: "Εξαγωγή σε CSV",
              exportPDFName: "Εξαγωγή σε PDF",
            },
            pagination: {
              firstTooltip: "Πρώτη Σελίδα",
              lastTooltip: "Τελευταία Σελίδα",
              previousTooltip: "Προηγούμενη Σελίδα",
              nextTooltip: "Επόμενη Σελίδα",
              labelDisplayedRows: "{from}-{to} από {count}",
              labelRowsSelect: "Εγγραφές ανά Σελίδα",
            },
            grouping: {
              placeholder: "Σύρετε για να ομαδοποιήσετε",
              groupedBy: "Σύρετε για να ομαδοποιήσετε",
            },
            header: {
              actions: "Ενέργειες",
            },
          }}
          options={{
            searchFieldAlignment: "left",
            exportPdf: (columns, data) => {
              exportPDF(columns, data);
            },
            exportCsv: (columns, data) => {
              exportCSV(columns, data);
            },
            columnsButton: true,
            paging: false,
            exportButton: true,
            grouping: false,
            sorting: true,
            search:false,
            filtering: false,
            exportAllData: true,
          }}
        />
      ) : (
        <CircularProgress></CircularProgress>
      )}
    </div>
  );
};

export default AverageTimes;
